/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STATES : LOAD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	loadstate: {
		textAlign: 'center',
		'& .illustration': {
			opacity: '0',
			animationName: 'fadeInUp',
			animationDelay: '0s',
			animationDuration: '.4s',
			animationFillMode: 'forwards',
			margin: replacePXinStringWithEM(`50px auto 30px`)
		},
		'& .bodycopy': {
			opacity: '0',
			animationName: 'fadeInUp',
			animationDelay: '.2s',
			animationDuration: '.2s',
			animationFillMode: 'forwards',
			maxWidth: pxToEm(655),
			'& p': {
				fontSize: pxToEm(22),
				'& .accent': {
					color: theme.color.primary.medium.swatch,
					opacity: '1'
				}
			}
		},
		'& .loader': {
			opacity: '0',
			animationName: 'fadeInUp',
			animationDelay: '.2s',
			animationDuration: '.3s',
			animationFillMode: 'forwards',
			fontSize: '200%'
		}
	}
});